import { Link } from 'react-router-dom';

export default function NotFound() {
  return (
    <div className="min-h-screen bg-ink-950 text-white flex items-center justify-center px-6 relative overflow-hidden">
      <div className="absolute inset-0 grid-bg opacity-30" />
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,rgba(139,92,246,0.2),transparent_60%)]" />
      <div className="relative text-center">
        <div className="font-display text-8xl md:text-[10rem] font-bold text-gradient leading-none">404</div>
        <p className="mt-4 text-white/70">This route drifted into deep space.</p>
        <Link to="/" className="btn-primary inline-flex mt-8 text-white font-semibold px-6 py-3 rounded-md text-sm">
          Back to Home
        </Link>
      </div>
    </div>
  );
}